<template>
  <div>
    <HvhChart
      :visualization="currentVisualization"
      :options="options"
      :height="height"
      :isEditMode="true"
      @item-clicked="itemClicked"
      @wheel="$emit('wheel', $event)"
      @chart-rendered="$emit('chart-rendered', $event)"
      @dataCreated="$emit('dataCreated', $event)"
      v-if="isEditMode"
    />
    <HvhChart :visualization="currentVisualization" :options="options" :height="height" @wheel="$emit('wheel', $event)" @chart-rendered="$emit('chart-rendered', $event)" @dataCreated="$emit('dataCreated', $event)" v-else />
    <div class="hvh-edit-position px-0" style="margin-right: 15px">
      <template v-if="isEditMode">
        <v-icon @click.stop="cancelEdit">mdi-close-circle</v-icon>
        <v-icon @click.stop="saveEdit">mdi-content-save-edit</v-icon>
      </template>
      <v-icon @click.stop="$emit('edit-mode-changed', !isEditMode)" v-else>mdi-pencil</v-icon>
    </div>
  </div>
</template>

<script>
import HvhChart from './HvhChart';

export default {
  components: { HvhChart },
  props: ['visualization', 'options', 'height', 'isEditMode'],
  data() {
    return {
      currentVisualization: null,
      uncheckedItemsHistory: null,
      checkedItemsHistory: null,
    };
  },
  methods: {
    createCurrentVisualization() {
      this.currentVisualization = {
        ...this.visualization,
        data: this.visualization.data.filter(f => this.isEditMode ? true : !f.unchecked)
      };
    },
    createHistoryObjects() {
      this.checkedItemsHistory = this.visualization.data.filter(f => !f.unchecked);
      this.uncheckedItemsHistory = this.visualization.data.filter(f => f.unchecked);
    },
    itemClicked(item, event) {
      var selectedItem = this.visualization.data[event.data.dataIndex];
      this.$set(selectedItem, 'unchecked', !selectedItem.unchecked)
      this.createCurrentVisualization();
    },
    saveEdit() {
      this.$emit('edit-mode-changed', !this.isEditMode);
      this.$emit('items-checked', this.visualization.data);
    },
    cancelEdit() {
      this.checkedItemsHistory.forEach(f => f.unchecked = false);
      this.uncheckedItemsHistory.forEach(f => f.unchecked = true);
      this.$emit('edit-mode-changed', !this.isEditMode);
    }
  },
  beforeMount() {
    this.createCurrentVisualization();
    this.createHistoryObjects();
  },
  watch: {
    visualization() {
      this.createCurrentVisualization();
      this.createHistoryObjects();
    },
    isEditMode() {
      this.createCurrentVisualization();
      this.createHistoryObjects();
    },
  },
}
</script>